// extracted by mini-css-extract-plugin
export var btnBlock = "screen1-module--btn-block--0c602";
export var date = "screen1-module--date--62f66";
export var desc = "screen1-module--desc--d7fa3";
export var info = "screen1-module--info--99ca8";
export var screen1 = "screen1-module--screen1--5384e";